import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  /* Global Reset */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* Apply the Fireblocks-Style Background Globally */
  body {
    font-family: ${({ theme }) => theme.typography.fonts.primary};
    color: ${({ theme }) => theme.colors.text.primary};
    background-color: ${({ theme }) => theme.colors.neutral[200]};
    line-height: 1.6;
    padding-top: 80px;
    position: relative;
    overflow-x: hidden;

    /* Smaller, Subtle Dot Grid */
    background-image: radial-gradient(circle, rgba(0, 0, 0, 0.06) 1px, transparent 1px);
    background-size: 8px 8px; 
    background-position: center;

    /* Soft Glow Overlay */
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 80px;
      background: radial-gradient(circle, rgba(0, 0, 0, 0.04) 0%, transparent 60%);
      transform: translate(-50%, -50%);
      z-index: -1;
    }

    /* Subtle Animated Glow */
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.03) 0%, transparent 70%);
      opacity: 0.7;
      animation: pulseGlow 6s infinite ease-in-out;
      z-index: -1;
    }

    @keyframes pulseGlow {
      0% { opacity: 0.4; }
      50% { opacity: 0.7; }
      100% { opacity: 0.4; }
    }
  }

  /* Headings */
  h1, h2, h3, h4, h5, h6 {
    font-weight: ${({ theme }) => theme.typography.weights.bold};
  }

  h1 {
    font-size: ${({ theme }) => theme.typography.sizes.lg};
  }

  h2 {
    font-size: ${({ theme }) => theme.typography.sizes.md};
  }

  h3 {
    font-size: ${({ theme }) => theme.typography.sizes.sm};
  }

  /* Links */
  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primary.main};
    transition: color 0.3s ease;

    &:hover {
      color: ${({ theme }) => theme.colors.secondary.main};
    }
  }

  /* Buttons */
  button {
    cursor: pointer;
    border: none;
    font-weight: ${({ theme }) => theme.typography.weights.semibold};
    transition: background 0.3s ease;
  }

  /* Sections */
  section {
padding: ${({ theme }) => theme.spacing.lg} 0; /* ✅ Reduced padding */
  max-width: ${({ theme }) => theme.layout.maxWidth};
  margin: 0 auto;
  }

  section:not(:last-child) {
  border-bottom: 3px solid ${({ theme }) => theme.colors.neutral[600]}; /* ✅ Soft gray separator */
  padding-bottom: ${({ theme }) => theme.spacing.lg}; /* ✅ Keeps spacing balanced */
}

`;
